import { createContext } from 'react';

export const MessageContext = createContext({ 
    addMessage: () => {}
});